import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_arrow_down",
  "use": "icon-ic_arrow_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ic_arrow_down\">\n<path d=\"M12 14.4752L19.7782 6.69702L21.1924 8.11123L12.3536 16.9501C12.1583 17.1454 11.8417 17.1454 11.6465 16.9501L2.80762 8.11123L4.22184 6.69702L12 14.4752Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol